import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import * as stylex from "@stylexjs/stylex";
import { queries, errorMessage } from "../lib/api";
import { styles } from "../lib/styles";
export const Route = createFileRoute("/audit")({ component: ActivityPage });
function ActivityPage() {
  const state = useQuery(queries.state());
  return (
    <>
      <div {...stylex.props(styles.pageHeading)}>
        <div>
          <h1 {...stylex.props(styles.title)}>Activity</h1>
          <p {...stylex.props(styles.description)}>
            Certificate requests, administrative changes, and server authorization results. This is
            an access audit, not a recording of terminal sessions.
          </p>
        </div>
      </div>
      {state.error && (
        <p role="alert" {...stylex.props(styles.error)}>
          {errorMessage(state.error)}
        </p>
      )}
      <section {...stylex.props(styles.panel)}>
        <div {...stylex.props(styles.tableWrap)}>
          <table {...stylex.props(styles.table)}>
            <thead>
              <tr>
                {["When", "Identity", "Action", "Target", "Details"].map((h) => (
                  <th key={h} {...stylex.props(styles.th)}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {state.data?.events.map((event) => (
                <tr key={event.id}>
                  {[
                    new Date(event.at).toLocaleString(),
                    event.actor,
                    event.action,
                    event.target,
                    event.detail,
                  ].map((v, i) => (
                    <td key={`${event.id}-${i}`} {...stylex.props(styles.td)}>
                      {v}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {state.data?.events.length === 0 && (
          <p {...stylex.props(styles.empty)}>No activity recorded yet.</p>
        )}
      </section>
    </>
  );
}
